var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgGuestbook = function SvgGuestbook(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 17,
    viewBox: "0 0 15 17",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.607 3.09091H12.8436V0.772727C12.8436 0.567787 12.7632 0.371241 12.62 0.226327C12.4769 0.0814121 12.2827 0 12.0803 0H2.91976C2.31238 0 1.72988 0.244236 1.3004 0.67898C0.870919 1.11372 0.629639 1.70336 0.629639 2.31818V14.6818C0.629639 15.2966 0.870919 15.8863 1.3004 16.321C1.72988 16.7558 2.31238 17 2.91976 17H13.607C13.8095 17 14.0036 16.9186 14.1468 16.7737C14.29 16.6288 14.3704 16.4322 14.3704 16.2273V3.86364C14.3704 3.6587 14.29 3.46215 14.1468 3.31724C14.0036 3.17232 13.8095 3.09091 13.607 3.09091ZM11.3169 7.72727H3.68314V6.18182H11.3169V7.72727ZM11.3169 3.09091H2.95793C2.76933 3.0944 2.58556 3.03045 2.43895 2.91031C2.29234 2.79017 2.19229 2.62154 2.15639 2.43409C2.13978 2.32334 2.14716 2.21026 2.17801 2.10269C2.20887 1.99511 2.26246 1.89561 2.33507 1.81109C2.40768 1.72656 2.49759 1.65902 2.59854 1.61315C2.6995 1.56729 2.80911 1.54419 2.91976 1.54545H11.3169V3.09091Z",
    fill: "#232323"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgGuestbook, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/guest book.05e82826.svg";
export { ForwardRef as ReactComponent };